const hh50AMIExpression =
  '($feature.HH_blw4p50AMI / $feature.TOTAL_HH_FOR_INCOME)';
const hh80AMIExpression =
  '($feature.HH_blw4p80AMI / $feature.TOTAL_HH_FOR_INCOME)';
const zeroExpression = '($feature.HH_blw4p80AMI == 0)';

function getClassBreaksRenderer() {
  const outline = {
    color: [0, 0, 0, 0.3],
    width: 0.1,
  };
  return {
    type: 'unique-value',
    valueExpression: `
    IIf(${zeroExpression}, 'gray',
    IIf(${hh50AMIExpression} >= 0.6, 'red',
    IIf(${hh80AMIExpression} >= 0.6, 'yellow', 'white')))
     `,
    uniqueValueInfos: [
      {
        value: 'red',
        symbol: {
          type: 'simple-fill',
          color: 'rgba(107, 0, 0, .8)',
          outline,
        },
      },
      {
        value: 'yellow',
        symbol: {
          type: 'simple-fill',
          color: 'rgba(255, 198, 39, .8)',
          outline,
        },
      },
      {
        value: 'white',
        symbol: {
          type: 'simple-fill',
          color: 'rgba(255, 255, 255, .3)',
          outline,
        },
      },
      {
        value: 'gray',
        symbol: {
          type: 'simple-fill',
          // style: 'forward-diagonal',
          color: 'rgba(128, 128, 128, .7)',
          outline,
        },
      },
    ],
  };
}

export default getClassBreaksRenderer;
